<button mat-icon-button class="disabledWhite" [disabled]="selectionModel.selected.length === 0" (click)="askBeforeRemoveFavorite(selectionModel.selected)" >
    <mat-icon>delete_sweep</mat-icon>
</button>
